import { LoadingSkeleton, PageGridContainer, PageGridItem, tokens } from 'ComponentLibrary'
import { useValuationMarketDataPage } from './ValuationMarketDataPage.data'
import { Box, Stack } from '@mui/material'
import { PREVIEW_WIDTH, ValuationComparables } from './Comparables/ValuationComparables'

export default function ValuationMarketDataPage() {
    const { asset, valuation, isComparablesPending } = useValuationMarketDataPage()

    return (
        <PageGridContainer>
            <PageGridItem columnSpan={6} columnSpanXs={4}>
                {isComparablesPending ? (
                    <Stack direction="row" gap={tokens.SizingSpacing200} position="relative">
                        <Box width={`calc(100% - ${PREVIEW_WIDTH} - ${tokens.SizingSpacing200})`}>
                            <LoadingSkeleton variant="rounded" height="700px" />
                        </Box>
                        <Box width={PREVIEW_WIDTH}>
                            <LoadingSkeleton variant="rounded" height="300px" />
                        </Box>
                    </Stack>
                ) : (
                    <ValuationComparables asset={asset} valuation={valuation} />
                )}
            </PageGridItem>
        </PageGridContainer>
    )
}
